export default __webpack_public_path__ + "20ba7c499cd7ebf22439b7ba8e8de849.svg";